import BaseSystemApi from 'api/BaseSystemApi';
import { env } from 'env';

export default class CoreSystemApi<Resource = unknown> extends BaseSystemApi<Resource> {
  protected origin = env.REACT_APP_CORE_API_URL;
}
